import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import axios from "axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { toast } from "react-toastify";
import "./SignInForm.css";

export default function SignInForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const user = sessionStorage.getItem("user");

    if (token && user) {
      navigate("/upload-flight", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !password) {
      toast.error("Please fill in all required fields.");
      return;
    }

    setIsLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/signin`,
        {
          email,
          password,
        }
      );

      sessionStorage.setItem("token", res.data.token);
      sessionStorage.setItem("user", JSON.stringify(res.data.user));

      toast.success(res.data.message || "Login successful!");
      navigate("/upload-flight", { replace: true });
    } catch (err) {
      setPassword("");
      toast.error(err.response?.data?.message || "Invalid email or password");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signin-container-inp">
      <div className="signin-card-inp">
        <div className="signin-header-inp">
          <h2 className="signin-title-inp">Welcome</h2>
        </div>

        <form onSubmit={handleSubmit} className="signin-form-inp">
          <div className="form-group-inp">
            <label className="form-label-inp">
              Email Address <span className="required-inp">*</span>
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="form-input-inp"
              placeholder="Enter your email"
            />
          </div>

          <div className="form-group-inp">
            <label className="form-label-inp">
              Password <span className="required-inp">*</span>
            </label>

            <div className="password-input-wrapper-inp">
              <input
                type={showPass ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-input-inp password-input-inp"
                placeholder="Enter your password"
              />

              <span
                className="password-toggle-inp"
                onClick={() => setShowPass(!showPass)}
              >
                {showPass ? <FaEyeSlash size={20} /> : <FaEye size={20} />}
              </span>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className={`submit-button-inp ${isLoading ? "loading-inp" : ""}`}
          >
            {isLoading ? (
              <>
                <span className="spinner-inp"></span>
                Signing In...
              </>
            ) : (
              "Sign In"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}